import React, { FC, MouseEvent } from 'react';
import clsx from 'clsx';
import Tooltip from '@material-ui/core/Tooltip';
import IconButtonUI from '@material-ui/core/IconButton';
import IconUI from '@mdi/react';

import useStyles from './styles';

interface IProps {
  path?: string;
  size?: 'medium' | 'small';
  title?: string;
  disabled?: boolean;
  className?: string;
  classNameWrap?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  style?: object;
  children?: React.ReactElement;
  sizeIcon?: number;
}

const IconButton: FC<IProps> = ({
  title, path, disabled, classNameWrap, size, children, sizeIcon, ...other
}) => {
  const classes = useStyles();

  return (
    <>
      {title && !disabled ? (
        <span className={classNameWrap}>
          <Tooltip title={title}>
            {getInnerButton()}
          </Tooltip>
        </span>
      ) : (
        <span className={classNameWrap}>
          {getInnerButton()}
        </span>
      )}
    </>
  );

  function getInnerButton() {
    return (
      <span>
        <IconButtonUI aria-label={title} size={size || 'medium'} disabled={disabled} {...other} component="span">
          {children || (
          <IconUI
            className={clsx(classes.icon, { [classes.iconDisabled]: disabled })}
            path={path as never}
            size={getSize(size || 'medium', sizeIcon)}
          />
          )}
        </IconButtonUI>
      </span>

    );
  }

  function getSize(size: 'medium' | 'small', sizeIcon?: number) {
    if (sizeIcon) {
      return sizeIcon;
    }
    if (size === 'small') {
      return 0.7;
    }
    return 1;
  }
};

export default IconButton;
